// ── Pinned repos — shown first, in this order ─────────────────────
export const PINNED = [
  'Backlot-Film-Maker',
  'ow-socrates',
  'godot-HD-SleepingIron',
  'master-resume',
  'SYNAB-LLC',
  'React-Portfolio',
];

// ── Hidden repos — never shown (course assignments, trivial forks) ─
export const HIDDEN = new Set([
  // Course assignments / exercises
  'CS665-Final-Project-DBS',
  'CS-665-Assignment-1',
  'CS-665-Assignment-2',
  'CS-665-Assignment-3',
  'CS-665-Assignment-4',
  'CS-Assignment-6',
  'MIPS-PIPELINED-DATAPATH',
  'MIPS-CACHE',
  'MIPS-DECODER',
  'mp-2', 'mp-3', 'mp-4', 'mp-5', 'mp-6',
  'https---github.com-AJun01-mp-1',
  'term-project',
  // Forks of other people's repos
  'portfolio-francise',
  'meshery',
  'layer5',
  'seprojects-cs673olf24team1',
  // Trivial / scratch
  'Loan-Application-Form-',
  'job-list',
  'grocerella',
  'wedding-app',
  'Magic-Number',
  'AJun01',           // profile readme repo
]);

// ── Language color map (cyberpunk palette) ─────────────────────────
export const LANG_COLORS = {
  JavaScript:  '#f0db4f',
  TypeScript:  '#007acc',
  Python:      '#3572a5',
  Java:        '#b07219',
  HTML:        '#e44b23',
  CSS:         '#563d7c',
  Go:          '#00add8',
  GDScript:    '#355570',
  default:     'rgba(0, 220, 255, 0.5)',
};
